import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes, useAppSelector } from "src/common";
import { Icon } from "src/components";
import { RootState } from "src/store/configureStore";

type AllProps = {
  is_loading: boolean;
  groups_aliases: string[];
  handleAction: ActionHandlerFunction;
}

// Description: Toolbar component for the User Groups list view. Actions include creating a new group, copying an existing group (only available when one group is selected),
// deleting selected groups, and refreshing the list. It also displays the count of groups currently available.
function ToolbarComponent(props: AllProps) {
  const { is_loading, groups_aliases, handleAction } = props;
  const selected = useAppSelector((state: RootState) => state.admin.selected);

  return <Row className="toolbar admin">
    <Col className="order-1">
      <Button
        className="ms-1 action-toolbar-buttons"
        variant="icon"
        size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.ShowModal })}
        title="Create Email Group"
        data-tooltip-id="tb-tooltip"
        data-tooltip-content="Create Email Group"
      >
        <Icon className="ficon-plus" />
      </Button>
      <Button
        className="action-toolbar-buttons"
        variant="icon"
        size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.Copy })}
        disabled={selected.length !== 1}
        title="Copy Selected"
        data-tooltip-id="tb-tooltip"
        data-tooltip-content="Copy Selected"
      >
        <Icon className="ficon-copy" />
      </Button>
      <Button
        className="action-toolbar-buttons"
        variant="icon"
        size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.Delete })}
        disabled={selected.length === 0}
        title="Delete Selected"
        data-tooltip-id="tb-tooltip"
        data-tooltip-content="Delete Selected" >
        <Icon className="ficon-trash-2" />
      </Button>
    </Col>
    <Col xs="auto" className="order-sm-3 order-4 me-2 pagination_info">
      {groups_aliases.length > 0 && `${groups_aliases.length} ${groups_aliases.length > 1 ? "User Groups" : "User Group"}`}
    </Col>
    <Col className="divider order-sm-3 order-1"></Col>
    <Col xs="auto" className="p-0 order-sm-3 order-4 ms-1 refresh" >
      <Button variant="icon" size="sm"
        onClick={() => handleAction({ actionType: AdminUIActionTypes.Refresh })}
        data-tooltip-id="tb-tooltip"
        data-tooltip-content="Refresh Users">
        {
          is_loading ?
            <i className="spinner"></i> :
            <Icon className="ficon-rotate-cw" />
        }
      </Button>
    </Col>
  </Row >;
}

export default React.memo(ToolbarComponent);